import { AppModules } from 'appContainer/types';
import { stringParam } from 'router/declarative/paramRegistry';
import { PathRouteContent, RouteNode } from 'router/declarative/routeNode';
import { presentationParamDeclarations } from 'router/presentation/presentationParamDeclarations';
import { DEFAULT_EXTERNAL_DOCUMENT_TITLE } from './const';

export const routes = {
  path: '/external-document',
  title: DEFAULT_EXTERNAL_DOCUMENT_TITLE,
  appModule: AppModules.EXTERNAL_DOCUMENT,
  content: async (): PathRouteContent =>
    (await import('./ExternalDocumentLayout')).ExternalDocumentLayout,
  children: [
    {
      path: '/:externalDocumentId',
      searchParams: {
        ...presentationParamDeclarations,
        documentTitle: stringParam,
      },
      content: async (): PathRouteContent =>
        (await import('./ExternalDocumentPage')).ExternalDocumentPage,
    },
  ],
} as const satisfies RouteNode;
